import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d3c217c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d3c217c')) {
      api.createRecord('4d3c217c', component.options)
    } else {
      api.reload('4d3c217c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d3c217c", function () {
      api.rerender('4d3c217c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/components/AppointDelivery/parcel/index.vue"
export default component.exports